<template>
    <div v-show="show">
        <div id="cursorSettingDialog">
            <div class="dialog h-center">
                <CommonWindow :title="title" @close="close()">
                    <div class="title-function">
                        <div class="tab-pages">
                            <div @click="switchEdit('quick', $event)" :class="{ editting: editSwitch }">
                                <span>{{ rightTag }}</span>
                            </div>
                            <div @click="switchEdit('custom', $event)" :class="{ editting: !editSwitch }">
                                <span>{{ leftTag }}</span>
                            </div>
                        </div>
                        <div class="switch-cursor-btns">
                            <span>中右鍵互換</span>
                            <div class="toggle" :class="{ 'toggle-left': switchButton, 'toggle-right': !switchButton }" @click="toggleSwitchButton()"></div>
                        </div>
                    </div>
                    <!-- 自訂義滑鼠快捷功能 -->
                    <div v-if="editSwitch" id="content-quick" class="sub-content h-center">
                        <div class="main-content">
                            <div class="options">
                                <div class="title">所有快顯功能</div>
                                <div class="content">
                                    <div
                                        v-for="(item, index) in quickOptions"
                                        :key="index"
                                        class="option"
                                        :class="{ selected: nowSelected == item.tool }"
                                        @click="selectTool(item.tool)"
                                    >
                                        <div class="cursorShortcut" :class="[item.tool]"></div>
                                        <div class="txt">{{ item.toolName }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="change-buttons">
                                <div class="right-btn" @click="addToQuickShortcuts()"></div>
                                <div class="left-btn" @click="removeQuickShortcuts()"></div>
                            </div>
                            <div class="options">
                                <div class="title">自訂快顯功能</div>
                                <div class="content">
                                    <div
                                        v-for="(item, index) in quickShortcuts"
                                        :key="index"
                                        class="option custom-text"
                                        :class="{ selected: nowSelectedIndex == index }"
                                        @click="selectToolIndex(index)"
                                        @dblclick="doubleClick(item)"
                                    >
                                        <div class="cursorShortcut" :class="item.tool"></div>
                                        <span>{{ item.toolName }}</span>
                                        <span v-if="item.toolValue.color">{{ item.toolValue.color }}</span>
                                        <span v-if="item.toolValue.brushType">{{ item.toolValue.brushType }}</span>
                                        <span v-if="item.toolValue.solid">{{ item.toolValue.solid }}</span>
                                        <span v-if="item.toolValue.brushSize">寬{{ item.toolValue.brushSize }}</span>
                                        <span v-if="item.toolValue.fontSize">字級{{ item.toolValue.fontSize }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 自訂義右鍵選單 -->
                    <div v-else id="content-custom" class="sub-content h-center">
                        <div class="title-content"></div>
                        <div class="main-content">
                            <div class="options">
                                <div class="title">所有快顯功能</div>
                                <div class="content">
                                    <div
                                        v-for="(item, index) in customOptions"
                                        :key="index"
                                        v-show="item.show"
                                        @click="selectTool(item.tool)"
                                        class="option"
                                        :class="{ selected: nowSelected == item.tool }"
                                    >
                                        <div class="cursorShortcut" :class="[item.tool]"></div>
                                        <div class="txt">{{ item.toolName }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="change-buttons">
                                <div class="right-btn" @click="addToCustomShortcuts()"></div>
                                <div class="left-btn" @click="removeCustomShortcuts()"></div>
                            </div>
                            <div class="options">
                                <div class="title">自訂快顯功能</div>
                                <div class="content">
                                    <div
                                        v-for="(item, index) in customShortcuts"
                                        :key="index"
                                        v-show="item.show"
                                        @click="selectTool(item.tool)"
                                        class="option"
                                        :class="{ selected: nowSelected == item.tool }"
                                    >
                                        <div class="cursorShortcut" :class="[item.tool]"></div>
                                        <div class="txt">{{ item.toolName }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="buttons">
                        <div class="comfirm-btn" @click="useSetting()">套用</div>
                        <div class="cancel-btn" @click="close()">取消</div>
                    </div>
                </CommonWindow>
            </div>
        </div>
        <CursorPaintBoard ref="CursorPaintBoardCom" @updatePainter="updatePainter"></CursorPaintBoard>
    </div>
</template>

<script>
import CommonWindow from "@/components/common/CommonWindow.vue";
import CursorPaintBoard from "@/components/cursor/CursorPainter.vue";
import { CURSOR_TOOLS } from "@/js/toolbar/tools";
import DEFINE from "@/js/painter/define";
import EventBus from "@/js/event_bus";
import Cursor from "@/js/cursor/cursor.js";

export default {
    name: "cursor-setting",
    components: { CommonWindow, CursorPaintBoard },
    data: function () {
        return {
            publicPath: process.env.BASE_URL,
            title: "自訂滑鼠選單",
            show: false,
            nowEdit: "quick",
            rightTag: "中鍵功能設定",
            leftTag: "右鍵功能設定",
            switchButton: false,
            nowSelected: "",
            nowSelectedIndex: -1,
            _quickOptions: [CURSOR_TOOLS.PEN, CURSOR_TOOLS.HIGHLIGHTER, CURSOR_TOOLS.SELECTION, CURSOR_TOOLS.ERASER],
            defaultShortcutSetting: [
                {
                    type: "drawingPen-tool",
                    operate: 1,
                    color: "紅",
                    colorSetting: DEFINE.COLOR.PEN.RED,
                    brushType: "自由",
                    brushSetting: DEFINE.DRAW_STYLE.FREE,
                    solid: "空心",
                    soildSetting: true,
                    brushSize: "3",
                },
                {
                    type: "drawingPenLight-tool",
                    operate: 2,
                    color: "黃",
                    colorSetting: DEFINE.COLOR.HIGHLIGHTER.YELLOW,
                    brushType: "直線",
                    brushSetting: DEFINE.DRAW_STYLE.STRAIGHT_LINE,
                    solid: "空心",
                    soildSetting: true,
                    brushSize: "3",
                },
                {
                    type: "arrow-tool",
                },
                {
                    type: "eraser-tool",
                },
            ],
            defaultCustomShortcuts: [
                {
                    show: true,
                    tool: "pen",
                    toolName: "畫筆",
                },
                {
                    show: true,
                    tool: "highlighter",
                    toolName: "螢光筆",
                },
                {
                    show: true,
                    tool: "selection",
                    toolName: "選取",
                },
                {
                    show: true,
                    tool: "eraser",
                    toolName: "橡皮擦",
                },
                {
                    show: true,
                    tool: "text_box",
                    toolName: "文字方塊",
                },
            ],
            quickOptions: [],
            quickShortcuts: [],
            customOptions: [],
            customShortcuts: [],
        };
    },
    computed: {
        editSwitch: function () {
            return this.nowEdit === "quick";
        },
    },
    methods: {
        switchToolBox(show) {
            this.show = show;
        },
        switchEdit: function (value, event) {
            this.nowEdit = value;
        },
        updatePainter(data) {
            let currentItem = this.quickShortcuts[this.nowSelectedIndex];
            currentItem.toolValue = data;
        },
        close() {
            this.show = false;
        },
        selectTool: function (tool) {
            this.nowSelected = tool;
            this.nowSelectedIndex = -1;
        },
        selectToolIndex: function (index) {
            this.nowSelectedIndex = index;
            this.nowSelected = "";
        },
        addToCustomShortcuts: function () {
            // 如果沒有選取功能就不能新增過去自訂義的欄位
            if (this.nowSelected.length == 0) return;
            for (let i = 0; i < this.customOptions.length; i++) {
                if (this.customOptions[i].tool == this.nowSelected) {
                    this.customShortcuts.push(JSON.parse(JSON.stringify(this.customOptions[i])));
                    this.customOptions[i].show = false;
                    this.nowSelected = "";
                }
            }
        },
        removeCustomShortcuts: function () {
            if (this.nowSelected) {
                for (let i = 0; i < this.customShortcuts.length; i++) {
                    if (this.customShortcuts[i].tool == this.nowSelected) {
                        this.customShortcuts.splice(i, 1);
                    }
                }
            } else {
                this.nowSelected = this.customShortcuts.pop().tool;
            }

            for (let i = 0; i < this.customOptions.length; i++) {
                if (this.customOptions[i].tool == this.nowSelected) {
                    this.customOptions[i].show = true;
                }
            }
            this.nowSelected = "";
        },
        addToQuickShortcuts: function () {
            for (let i = 0; i < this.quickOptions.length; i++) {
                if (this.quickOptions[i].tool == this.nowSelected) {
                    this.quickShortcuts.push(JSON.parse(JSON.stringify(this.quickOptions[i])));
                    break;
                }
            }
        },
        removeQuickShortcuts: function () {
            this.quickShortcuts.splice(this.nowSelectedIndex, 1);
            this.nowSelectedIndex = -1;
        },
        readCursorMenu: function () {
            this.quickShortcuts = JSON.parse(JSON.stringify(cursorMenu.quickShortcutsMenu.shortcuts));

            let i = 0,
                j = 0;
            this.customShortcuts.length = 0;
            for (i = 0; i < this.customOptions.length; i++) {
                this.customOptions[i].show = true;
            }

            for (i = 0; i < cursorMenu.customShortcutsMenu.shortcuts.length; i++) {
                for (j = 0; j < this.customOptions.length; j++) {
                    if (this.customOptions[j].tool == cursorMenu.customShortcutsMenu.shortcuts[i].tool) {
                        this.customShortcuts.push(JSON.parse(JSON.stringify(this.customOptions[j])));
                        this.customOptions[j].show = false;
                    }
                }
            }
        },
        toggleSwitchButton: function () {
            this.switchButton = !this.switchButton;
            Cursor.getInstance().setSwitch(this.switchButton);

            if (this.switchButton) {
                this.rightTag = "右鍵功能設定";
                this.leftTag = "中鍵功能設定";
            } else {
                this.rightTag = "中鍵功能設定";
                this.leftTag = "右鍵功能設定";
            }
        },
        doubleClick: function (item) {
            console.log(item);
            if (item.toolValue.type === "drawingPen-tool" || item.toolValue.type === "drawingPenLight-tool") {
                let operate = item.toolValue.type === "drawingPen-tool" ? DEFINE.OPERATE.PEN : DEFINE.OPERATE.HIGHLIGHTER;
                this.$refs.CursorPaintBoardCom.set(operate, item.toolValue);
                this.$refs.CursorPaintBoardCom.open();
            } else if (item.toolValue.type === "textBox-tool") {
                this.textBoxSetting.show = !this.textBoxSetting.show;
                this.textBoxSetting.setValue(item.toolValue);
            }
        },
        useSetting: function () {
            let saveData = {
                customShortcuts: this.customShortcuts,
                quickShortcuts: this.quickShortcuts,
            };

            EventBus.getInstance().emit("set_right_menu", this.customShortcuts);
            EventBus.getInstance().emit("set_middle_menu", this.quickShortcuts);
            EventBus.getInstance().emit("save_cursor_data", saveData);
            this.show = false;
        },
        loadSetting: function (data) {
            if(!data || !data.customShortcuts || !data.quickShortcuts) return;
            

            this.customShortcuts.length = 0;
            this.quickShortcuts.length = 0;

            Object.values(data.customShortcuts).forEach((item) => {
                this.customShortcuts.push(item);
                console.log(`+*+* customShortcuts item = `, item);
            });
            Object.values(data.quickShortcuts).forEach((item) => {
                this.quickShortcuts.push(item);
                console.log(`+*+* quickShortcuts item = `, item);
            });

            this.customOptions.forEach((item) => (item.show = true));
            this.quickOptions.forEach((item) => (item.show = true));

            let customShortcutsLength = this.customShortcuts.length;
            for (let i = 0, max = this.customOptions.length; i < max; i++) {
                if (customShortcutsLength == 0) break;
                for (let j = 0, jMax = customShortcutsLength; j < jMax; j++) {
                    if (this.customShortcuts[j].tool == this.customOptions[i].tool) {
                        this.customOptions[i].show = false;
                        customShortcutsLength--;
                        break;
                    }
                }
            }
        },
    },
    created: function () {
        for (let i = 0, jMax = this.defaultCustomShortcuts.length; i < Object.keys(CURSOR_TOOLS).length; i++) {
            let tool = CURSOR_TOOLS[Object.keys(CURSOR_TOOLS)[i]];
            let item = {
                tool: tool.TOOL,
                toolName: tool.TOOL_NAME,
                show: true,
            };
            this.customOptions.push(item);

            for (let j = 0; j < jMax; j++) {
                if (this.defaultCustomShortcuts[j].tool == item.tool) {
                    this.customShortcuts.push({
                        tool: tool.TOOL,
                        toolName: tool.TOOL_NAME,
                        show: true,
                    });
                    this.customOptions[i].show = false;
                    break;
                }
            }
        }

        for (let i = 0; i < this._quickOptions.length; i++) {
            let item = {
                tool: this._quickOptions[i].TOOL,
                toolName: this._quickOptions[i].TOOL_NAME,
                toolValue: this.defaultShortcutSetting[i],
            };
            this.quickOptions.push(item);
            this.quickShortcuts.push(item);
        }

        document.documentElement.style.setProperty("--window-devicePixelRatio", window.devicePixelRatio);
    },
};
</script>

<style src="@/css/cursor/cursorSettingDialog.css" scoped></style>
<style src="@/css/cursor/icon.css"></style>
<style scoped>
.dialog-window {
    top: 0%;
    height: 100%;
}

.option.custom-text {
    white-space: nowrap;
}

.windowscale-handle {
    transform: scale(calc(1 / var(--window-devicePixelRatio)));
}
</style>
<style>
#cursorSettingDialog .dialog > .dialog-window > .window-title {
    height: 45px;
}

#cursorSettingDialog .dialog > .dialog-window .window-title span {
    /* font-size: calc(28px / var(--window-devicePixelRatio)); */
    font-size: 28px;
}

#cursorSettingDialog .dialog > .dialog-window > .window-title .close-btn {
    position: absolute;
    background-size: contain;
    background-repeat: no-repeat;
    width: 10vh;
    height: 10vh;
    max-width: 30px;
    max-height: 30px;
    right: 10px;
    top: 10px;
}

#cursorSettingDialog > .dialog > .dialog-window > .window-content {
    background-color: #ececfb;
    border-radius: 5px;
}

#cursorSettingDialog * {
    /* font-size: calc(14px / var(--window-devicePixelRatio)); */
    font-size: 14px;
}
</style>
